export default {
      id: "pattern-mutame-lunette-noir-usage",
      viewBox: "0 0 161 166",
      url: "../icon/" + "icons.svg#pattern-mutame-lunette-noir-usage",
      toString: function () {
        return this.url;
      }
    }